// Update contents object below
const contents = {
  header: 'AWS Intel', //update with your client name
  logoTooltip: {
    href: '', //where the logo click drives to
    copy: '' // tooltip content
  },
  hero: {
    background: 'video', //options: "image" or "video"
    logoPlacement: 'top', //options: "top" or "center"
    title: 'Cloud Technology Helps Scientists Move Faster to Save Endangered Species',
    copy:
      'Researchers at the University of Sydney are building a digitized genomic library to meet Australia’s conservation goals.'
  },
  inlinePhotos: {
    size: 'bodyWidth', //options: "fullBleed" or "bodyWidth"
    contents: [
      {
        class: 'photo1',
        caption:
          'Scientists working with the Threatened Species Initiative (TSI) collect samples from threatened habitats. Genetic data extracted from the samples can guide conservation efforts. (Getty Images)'
      },
      {
        class: 'photo2',
        caption:
          'Conservation teams have limited funding and massive amounts of scientific data to analyze. That’s why TSI developed RONIN, a web-and-desktop–based platform running on AWS and Intel® Xeon® Scalable processors. RONIN gives researchers the flexibility to scale up or dial back supercomputing power on demand, so they can maximize the impact of each conservation dollar. (TSI)'
      },
      {
        class: 'photo3',
        caption:
          'The Threatened Species Initiative (TSI) began in Australia, but it aims to improve conservation practices everywhere by combining cutting-edge genomics technology with advanced computational biology. The cloud-based nature of RONIN helps researchers around the world easily access and share data, enabling the global collaboration needed to protect biodiversity on Earth. (Unsplash)'
      },
      {
        class: 'photo4',
        caption:
          'On Lord of the Rings: The Rings of Power, Company 3 colorist Skip Kimball was able to work from his home and collaborate with creatives, production managers, and in-house finishing editors worldwide. (Company 3)'
      },
      { class: 'photo5', caption: 'caption' },
      { class: 'photo6', caption: 'caption' },
      { class: 'photo7', caption: 'caption' },
      { class: 'photo8', caption: 'caption' }
    ] //add more objects in the array if you have more than one photo
  },
  ctaTooltip: {
    href:
      'https://aws.amazon.com/?trk=641443fe-4aa9-4b77-8cb6-4e3f8dc5e72b&sc_channel=display%20ads?utm_source=cnn&utm_medium=hyperlink&utm_campaign=gc-ngitl&utm_content=article3_ronin&utm_creative=link',
    copy: '', //tooltip content
    href2: 'https://www.youtube.com/c/AWSPublicSector'
  },
  pullQuoteContent: {
    pullQuote1:
      'Players who achieve extremely high scores in the app sometimes even get a chance to connect with a professional sports club for a tryout. “We’ve actually had a player who has done drills and had a call from the club on the same day. It’s happened that quickly,” says Richard Felton-Thomas, Director of Sport Science and COO at AiSCOUT. “It’s incredibly rewarding when a player gets signed who might never have been seen otherwise. It’s heartwarming, and it’s also a validation for the ability of this technology to change someone’s life.”',
    pullQuote2:
      'In fact, the program was such a huge success that India announced that it would make the Co-WIN platform open source so that all countries could save lives and protect health with a modern, cloud-based vaccine registration platform.'
  }
};

export default contents;
